import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await register(form.name.trim(), form.email.trim(), form.password);
      toast.success("Account created");
      nav("/");
    } catch (e2) {
      const msg = formatApiErrorDetail(e2.response?.data?.detail) || e2.message;
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="register-page" className="min-h-[70vh] flex items-center py-12">
      <div className="container-page grid md:grid-cols-2 gap-10 items-center">
        <div className="hidden md:block">
          <div className="text-xs font-bold uppercase tracking-widest text-accent mb-3">Join MyTripPoint</div>
          <h1 className="font-montserrat font-extrabold text-4xl lg:text-5xl text-slate-900 leading-tight">
            Travel smarter with personalised deals.
          </h1>
          <p className="mt-3 text-slate-600 max-w-md">
            Sign up free and start saving wishlists, tracking prices and unlocking exclusive partner fares.
          </p>
          <img src="https://images.unsplash.com/photo-1525625293386-3f8f99389edd?auto=format&fit=crop&w=1200&q=80" alt="" className="mt-8 w-full h-64 object-cover rounded-2xl border border-slate-200" />
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 max-w-md w-full mx-auto" data-testid="register-form">
          <h2 className="font-montserrat font-bold text-2xl text-slate-900">Create account</h2>
          <p className="text-sm text-slate-500 mt-1">Takes less than 30 seconds.</p>
          {err && <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="register-error">{err}</div>}
          <div className="mt-5 space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:outline-none focus:border-brand text-sm" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:outline-none focus:border-brand text-sm" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Password</label>
              <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:outline-none focus:border-brand text-sm" />
              <div className="text-[11px] text-slate-500 mt-1">At least 6 characters.</div>
            </div>
          </div>
          <button disabled={busy} data-testid="register-submit" className="mt-6 w-full h-12 rounded-lg btn-brand text-white font-semibold disabled:opacity-60">
            {busy ? "Creating..." : "Create account"}
          </button>
          <div className="text-sm text-slate-600 mt-4 text-center">
            Already have an account? <Link to="/login" className="text-brand font-semibold">Log in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
